import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { auth } from "../firebase"; // ✅ FIX: ADD THIS

export default function Yard() {
  const navigate = useNavigate();
  const location = useLocation();

  const user = auth.currentUser; // ✅ now works
  const isLoggedIn = !!user;

  const [dateTime, setDateTime] = useState("");

  const styles = {
content: {
  position: "relative",
  width: "100%",
  maxWidth: "600px",

  margin: "0 auto",
  padding: "0 10px",

  height: "calc(100vh - 150px)", // 👈 subtract header space EXACTLY

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",

  textAlign: "center",
  boxSizing: "border-box",
  
  fontSize: "16px",
  fontWeight: "400",
  color: "#555",
  lineHeight: "1.5",
},
  };

  // CLOCK
  useEffect(() => {
    const updateClock = () => {
      const now = new Date();

      const datePart = now.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });

      const dayPart = now.toLocaleDateString("en-US", {
        weekday: "long",
      });

      const timePart = now.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });

      setDateTime(`${dayPart} ✦ ${datePart} ✦ ${timePart}`);
    };

    updateClock();
    const interval = setInterval(updateClock, 1000);
    return () => clearInterval(interval);
  }, []);

const headerLineText = isLoggedIn
  ? "✦ We’re updating — see you soon ✦"
  : "✦ Be a member and create your story with us! ✦";

  return (
        <div
          style={{
            minHeight: '100vh',
            width: '100%',
            backgroundColor: 'linear-gradient(135deg, #e7e7e7, #dcdcdc), radial-gradient(circle at 30% 20%, rgba(255,255,255,0.4), transparent 40%), radial-gradient(circle at 70% 80%, rgba(0,0,0,0.08), transparent 45%)',
            fontFamily: '"Inter", sans-serif',
            color: '#000',
            overflowX: 'auto',
            overflowY: 'auto',
            paddingTop: '92px',
            boxSizing: 'border-box',
          }}
        >
          {/* HEADER */}
          <div
            style={{
              width: '100%',
              minHeight: '60px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingRight: '20px',
              paddingLeft: '20px',
              position: 'fixed',
              top: 0,
              backgroundColor: '#F2E7E0',
              color: '#000',
              zIndex: 100,
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', alignItems: 'center' }}>
              <span onClick={() => navigate(isLoggedIn ? "/home" : "/")} className={`nav-item ${location.pathname === "/" ? "active" : "" }`} > Home </span>
              <span onClick={() => navigate("/engage")} className={`nav-item ${location.pathname === "/engage" ? "active" : "" }`} > Engage </span>
              <span onClick={() => navigate('/yard')} className={`nav-item ${location.pathname === '/yard' ? 'active' : ''}`} > Yard </span>
            </div>
            <div className="datetime" style={{ fontWeight: 'normal', fontSize: '0.9rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
              {dateTime}
            </div>
          </div>

          {/* GRAY LINE */}
          <div style={{
            width: '100%',
            backgroundColor: '#696969',
            height: '23px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: '58px',
            zIndex: 90,
          }}>
            <span className="slide-right-text">{headerLineText}</span>
          </div>

      {/* CONTENT */}
      <div style={styles.content}>
        {isLoggedIn ? "We’re building something here — check back soon" : "Unlock space to discover more — return to HOME"}
      </div>

      {/* STYLES */}
      <style>{`
            .slide-right-text {
              color: #ffff;
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 100;
              letter-spacing: 1.1px;
              white-space: nowrap;
              position: relative;
              animation: slideRight 8s ease-in-out infinite;
            }
            @keyframes slideRight {
              0% { transform: translateX(120%) scaleY(.9); opacity: 0; }
              18.75% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              81.25% { transform: translateX(0%) scaleY(0.9); opacity: 1; }
              100% { transform: translateX(-120%) scaleY(0.9); opacity: 0; }
            }
              .nav-item {
              cursor: pointer;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              font-weight: 200;
              letter-spacing: .3px;
              transform: scaleY(.85) translateY(1px);
              text-transform: uppercase;
              display: inline-block;
              color: #464646;
            }

            /* Hover bounce */
            .nav-item:hover {
              color: #000;
            }

            /* Active tab */
            .nav-item.active {
              font-weight: 700;
              color: #000;
            }

            /* Keep hover working on active */
            .nav-item.active:hover {
            }

            @media (max-width: 600px) {
              .datetime {
              display: none !important; 
              }
            }

            .panel {
              max-width: 100%;
            }
              
            .datetime {
              display: inline-block;
              font-family: 'Inter', sans-serif;
              font-size: 14px;
              letter-spacing: 1px;
              transform: scaleY(.9);
            }
      `}</style>
    </div>
  );
}